import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { saveProject } from '../../actions/project'
import { toggleSidebar } from '../../actions/sidebar'
import Sidebar from './../../components/Sidebar'

const mapStateToProps = state => ({
  isClosed: dotProp.get(state, 'sidebar.isClosed', false),
  projectName: dotProp.get(state, 'project.name', ''),
  projectOrder: dotProp.get(state, 'project.order', ''),
})

const mapDispatchToProps = dispatch => ({
  toggleSidebar: () => dispatch(toggleSidebar()),
  saveProject: () => dispatch(saveProject()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar)



// WEBPACK FOOTER //
// ./src/containers/Sidebar/index.js